import { logger } from "@creditas/home-mf-shared";
import { ROOT_LOG_PREFIX } from "./consts";
import { getLead } from "../services";

function sleep(ms: number): Promise<void> {
  return new Promise((resolve) => {
    setTimeout(() => resolve(), ms);
  });
}

export async function getLastLeadRetry(
  customerId,
  retryN: number,
  delay = 6,
  time = 1000
) {
  try {
    const result = await getLead(customerId);
    logger.info({
      message: `[${ROOT_LOG_PREFIX}][CHECK_LEAD_ACTIVINESS] Retry lead n=${retryN} isActive=${result.isActive}`,
    });

    if (!result.isActive && retryN > 1) {
      await sleep((delay - retryN) * time);
      return await getLastLeadRetry(customerId, retryN - 1, delay, time);
    }

    return result;
  } catch (error) {
    if (retryN === 1) throw new Error(error);
    await sleep((delay - retryN) * time);
    return await getLastLeadRetry(customerId, retryN - 1, delay, time);
  }
}
